module.exports = __webpack_public_path__ + "media/print/color-settings_black-and-white-602dc782.png";